import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  rewardsClaimUpdated: {
    title: 'Rewards » Claimed Status Updated',
    description: 'Sent to employees when a claimed reward status is updated',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    fields: [
      {
        key: 'template.EMAIL_CLAIMED_REWARD_STATUS_CHANGED_BODY_ONE',
        label: 'Email bottom message',
        type: 'template',
        markdown: true,
      },
    ],
    sendTestEmail: buildTestEmail('rewards/claimed-status-changed', {
      template_bodyOne: 'template.EMAIL_CLAIMED_REWARD_STATUS_CHANGED_BODY_ONE',
    }, {
      data: {
        user: {
          claimedReward: {
            id: '301',
            reward: {
              id: '201',
              title: 'T-Shirt',
              customMessageLabel: 'What size would you like?',
            },
            user: {
              id: '101',
              fullName: 'James Dryden',
              emailAddress: 'james@reallinks.io',
            },
            employeeMessage: 'M or L please',
            recruiterMessage: null,
            status: 'REQUESTED',
          },
        },
      },
      variables: {
        claimedRewardID: 'rewards/claimed-status-changed send test email',
      },
    }),
    testDataQuery: getEmailQuery(),
    mockData(result) {
      const claimedReward = {
        id: '301',
        reward: {
          id: '201',
          title: 'T-Shirt',
          customMessageLabel: 'What size would you like?',
        },
        user: {
          id: '101',
          fullName: 'James Dryden',
          emailAddress: 'james@reallinks.io',
        },
        employeeMessage: 'M or L please',
        recruiterMessage: null,
        status: 'REQUESTED',
      };

      return {
        ...result,
        user: {
          ...result.user,
          claimedReward,
        },
      };
    },
  },
};


// WEBPACK FOOTER //
// ./src/emails/previews/rewardEmails.js